module.exports = __webpack_public_path__ + "img/p8.5af74543.png";